<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">


    <div class="box" style="margin:auto">

      <Card  :bordered="false" dis-hover style="margin-bottom:10px;">
        <div style="text-align:left">
          <Row>
            <Col span="19">
            <Button type="primary" @click="modal1=true">增加用户</Button>
            </Col>
            <Col span="5">
            <!--<Input search enter-button placeholder="输入关键词搜索" v-model="serch.key"  @on-search="load"/>-->
            </Col>
          </Row>
        </div>
      </Card>

      <Card dis-hover="true">
        <Spin fix v-if="loading"></Spin>
        <el-table :data="list" size="small" style="width: 100%" >
          <el-table-column prop="uid" label="用户ID" :show-tooltip-when-overflow="true"></el-table-column>
          <el-table-column prop="name" label="用户名称" :show-tooltip-when-overflow="true"></el-table-column>
          <el-table-column prop="user" label="登录账号" :show-tooltip-when-overflow="true"></el-table-column>
          <el-table-column prop="password" label="用户密码" :show-tooltip-when-overflow="true"></el-table-column>
          <el-table-column prop="roleName" label="角色" :show-tooltip-when-overflow="true"></el-table-column>
          <el-table-column prop="state" label="用户状态" :show-tooltip-when-overflow="true"></el-table-column>
          <el-table-column prop="ctime" label="注册时间" :show-tooltip-when-overflow="true"></el-table-column>
          <el-table-column prop="msg" label="操作" width="120">
            <template slot-scope="scope" >
              <a @click="edit(scope.row.id)"><i class="hs">&#xe61e;</i></a>
              <cite>|</cite>
              <a @click="remove(scope.row.id)" v-if="scope.row.uid!='mb0262zw'"><i class="hs">&#xe61c;</i></a>
            </template>
          </el-table-column>
        </el-table>
      </Card>

      <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
        <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
      </Card>

    </div>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save"
      width="380"
    >
      <Form :label-width="80">
        <FormItem label="用户名称" required>
          <Input v-model="detail.name"/>
        </FormItem>
        <FormItem label="登录账号" required>
          <Input v-model="detail.user"/>
        </FormItem>
        <FormItem label="用户密码" required>
          <Input v-model="detail.password"/>
        </FormItem>

        <FormItem label="用户角色" >
          <Select v-model="detail.roleId">
            <Option v-for="item in roles" :value="item.id" :label="item.name"></Option>
          </Select>
        </FormItem>

        <FormItem label="用户状态" required>
          <RadioGroup v-model="detail.state">
            <Radio label="正常"></Radio>
            <Radio label="停用"></Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>

  </div>
</template>

<script>
  export default {
    data(){
      return{
        baseUrl:'/api/user/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        loading:false,
        roles:[]
      }
    },
    methods:{
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.id@=@'+this.serch.key);
        }
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      },
      loadRoles(){
        let that = this;
        this.$axios.get('/api/power/powerrole/findall?page=1&limit=1000').then(function(rs){
          that.roles = rs.data.data;
        });
      }
    },
    created(){
      this.loadRoles();
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/User.vue